import * as LinearNumericScaling from './linearNumericScaling';
import { NumericRange, TimeRange } from '../types';
import { dateFromTimestamp } from '@ardoq/date-time';

export type TimeScalingFunction = (value: Date) => number;
export type TimeUnscalingFunction = (value: number) => Date;

type TimeScaler = (
  pixels: NumericRange,
  domain: TimeRange,
  zoom: NumericRange
) => TimeScalingFunction;

const toNumericRange = (range: TimeRange): NumericRange => [
  range[0].getTime(),
  range[1].getTime(),
];

export const xScaler: TimeScaler =
  (pixels: NumericRange, domain: TimeRange, zoom: NumericRange) => value =>
    LinearNumericScaling.xScaler(
      pixels,
      toNumericRange(domain),
      zoom
    )(value.getTime());

export const xUnscaler =
  (
    pixels: NumericRange,
    domain: TimeRange,
    zoom: NumericRange
  ): TimeUnscalingFunction =>
  value =>
    dateFromTimestamp(
      LinearNumericScaling.xUnscaler(
        pixels,
        toNumericRange(domain),
        zoom
      )(value)
    );
